import {FC, useState} from 'react';
import Details from './Details';
import Checklist from './Checklist';
import {CurrentTask} from '../../../types';

type BaseTaskProps = {
  task: CurrentTask,
  isCurrentUserAssignee: boolean,
  isRunning: boolean,
  hasClaimButton: boolean,
  alertRange: Nullable<number>,
  handleOpenClaimPopup: () => void,
  isSubmitting: boolean,
  submitTask: (values: Dictionary<string | string[]>) => void,
  notRunningStatus: boolean
};

const BaseTask: FC<BaseTaskProps> = ({
  task,
  handleOpenClaimPopup,
  hasClaimButton,
  isCurrentUserAssignee,
  isRunning,
  alertRange,
  isSubmitting,
  submitTask,
  notRunningStatus
}) => {
  const [isChecklistCompleted, setIsChecklistCompleted] = useState(false);

  return (
    <div className="current-task">
      <section className="current-task__section">
        <Details
          task={task}
          handleOpenClaimPopup={handleOpenClaimPopup}
          hasClaimButton={hasClaimButton}
          isCurrentUserAssignee={isCurrentUserAssignee}
          isChecklistCompleted={isChecklistCompleted}
          isRunning={isRunning}
          alertRange={alertRange}
          isSubmitting={isSubmitting}
          submitTask={submitTask}
          notRunningStatus={notRunningStatus}
        />
      </section>

      <section className="current-task__section">
        <Checklist
          items={task?.checklistItems}
          setIsChecklistCompleted={setIsChecklistCompleted}
          notRunningStatus={notRunningStatus}
          isDisabled={!isCurrentUserAssignee || !isRunning || isSubmitting}
        />
      </section>
    </div>
  );
};

export default BaseTask;
